import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import ImportPage from "@/pages/ImportPage";
import Editor from "@/pages/Editor";
import Publish from "@/pages/Publish";
import Team from "@/pages/Team";

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth return FIRST (synchronously during render) to avoid race conditions.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/library" element={<Library />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/editor/:id" element={<Editor />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/team" element={<ProtectedRoute adminOnly><Team /></ProtectedRoute>} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
